import { SaleItem } from '@repo/shared-types';
import { DateFormat, formatDate } from '../format/format-date';

interface ParsedTime {
  timeFrom: string;
  timeTo: string;
  items: SaleItem[];
}

interface ParsedDay {
  day: string;
  times: ParsedTime[];
}

const GROUP_TIME_INTERVAL_MINUTES = 30;

const getHalfHourInterval = (date: Date): { from: string; to: string } => {
  const minutes = date.getMinutes();

  const intervalStartMin = minutes < 30 ? 0 : 30;
  const intervalEnd = new Date(date);

  // Tiempo inicial
  const start = new Date(date);
  start.setMinutes(intervalStartMin, 0, 0);

  // Tiempo final = inicio + 30 min
  intervalEnd.setMinutes(intervalStartMin + GROUP_TIME_INTERVAL_MINUTES, 0, 0);

  return {
    from: formatDate(start, DateFormat.HH_MM),
    to: formatDate(intervalEnd, DateFormat.HH_MM),
  };
};

const parseItemsTimes = (items: SaleItem[]): ParsedTime[] => {
  const parsedTimes: ParsedTime[] = [];

  for (const item of items) {
    const date = new Date(item.createdAt);
    const { from, to } = getHalfHourInterval(date);

    // Buscar si ya existe este intervalo
    let interval = parsedTimes.find((t) => t.timeFrom === from && t.timeTo === to);

    if (!interval) {
      interval = { timeFrom: from, timeTo: to, items: [] };
      parsedTimes.push(interval);
    }

    interval.items.push(item);
  }

  return parsedTimes;
};

export const parseDayTime = (items: SaleItem[]): ParsedDay[] => {
  const parsedDays: ParsedDay[] = [];

  // Orden descendente por fecha
  const sorted = [...items].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );

  for (const item of sorted) {
    const date = new Date(item.createdAt);
    const day = formatDate(date, DateFormat.DD_MM_YYYY);

    let dayGroup = parsedDays.find((d) => d.day === day);

    if (!dayGroup) {
      dayGroup = {
        day,
        times: [],
      };
      parsedDays.push(dayGroup);
    }

    // Agrupar items del día
    const dayItems = sorted.filter(
      (i) => formatDate(new Date(i.createdAt), DateFormat.DD_MM_YYYY) === day
    );

    dayGroup.times = parseItemsTimes(dayItems);
  }

  return parsedDays;
};
